import React from 'react';
import { useAppSelector } from 'src/redux/hooks';
import { selectLearningPathwayById } from 'src/redux/slices/learningPathways';
import { selectIsWeblabInT1 } from 'src/redux/slices/weblabs';
import { WeblabId } from 'src/constants/weblab';
import { AppState } from 'src/redux/store';
import { useClientId, UNGATED_CLIENT_ID } from 'src/contexts/ClientContext';
import LearningPathwayPageHeader from './pageHeader';
import LearningPathwayAccordion from './moduleSectionAccordion';

export interface LearningPathwayProps {
  learningPathwayId: string
  onModuleSelect: (moduleId: string) => void
}

const LearningPathway = ({ learningPathwayId, onModuleSelect }: LearningPathwayProps) => {
  // Get the learning pathway data from Redux store
  const pathway = useAppSelector(
    (state: AppState) => selectLearningPathwayById(state, learningPathwayId),
  );

  const clientId = useClientId();
  const isWeblabT1 = useAppSelector(
    (state: AppState) => selectIsWeblabInT1(state, WeblabId.LearningPathwayPolyD),
  );
  // Ungated users always use static for now (non-localized) content regardless of weblab treatment.
  const isLocalized = isWeblabT1 && clientId !== UNGATED_CLIENT_ID;

  return (
    <>
      <LearningPathwayPageHeader
        title={pathway.data.title}
        description={pathway.data.description}
        imageSrc={pathway.data.imageSrc}
        stats={pathway.data.learningPathwayStats}
        isLocalized={isLocalized}
      />

      <LearningPathwayAccordion
        sections={pathway.data.sections}
        onModuleSelect={onModuleSelect}
        isLocalized={isLocalized}
      />
    </>
  );
};

export default LearningPathway;
